import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges
} from '@angular/core';

import { PaginatedDTO } from 'src/app/Common/common.interface';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnChanges {

  @Input() rowData: PaginatedDTO[] = [];
  @Input() EnablePageSize: boolean = false;
  @Input() EnableNavigation: boolean = false;

  @Output()
  pageSizeChanged: EventEmitter<{
    currentPage: number;
    pageSize: number;
  }> = new EventEmitter<{
    currentPage: number;
    pageSize: number;
  }>();

  currentPage: number = 1;
  totalPages: number = 0;
  pageSize: number = 10;
  totalRecords: number = 0;
  start: number = 0;
  end: number = 0;


  onPageSizeChanged(selectedValue: number): void {

    const numericPageSize = Number(selectedValue);

    if (
      !Number.isFinite(numericPageSize) ||
      numericPageSize <= 0
    ) {
      return;
    }

    this.pageSize = numericPageSize;
    this.currentPage = 1;

    this.pageSizeChanged.emit({
      currentPage: 1,
      pageSize: numericPageSize
    });
  }


  goToFirstPage(): void {

    if (this.currentPage !== 1 && this.totalPages > 0) {

      this.currentPage = 1;

      this.pageSizeChanged.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }


  goToPreviousPage(): void {

    if (this.currentPage > 1) {

      this.currentPage--;

      this.pageSizeChanged.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }


  getPagesToShow(): number[] {

    const pages: number[] = [];

    if (this.totalPages <= 7) {

      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }

    } else {

      let start = Math.max(2, this.currentPage - 1);
      let end = Math.min(
        this.totalPages - 1,
        this.currentPage + 1
      );

      if (this.currentPage <= 3) {
        start = 2;
        end = 4;
      }

      if (this.currentPage >= this.totalPages - 2) {
        start = this.totalPages - 3;
        end = this.totalPages - 1;
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }

    return pages;
  }


  goToNumberPage(page: number): void {

    if (
      page < 1 ||
      page > this.totalPages ||
      page === this.currentPage
    ) {
      return;
    }

    this.currentPage = page;

    this.pageSizeChanged.emit({
      currentPage: this.currentPage,
      pageSize: this.pageSize
    });
  }


  goToNextPage(): void {

    if (this.currentPage < this.totalPages) {

      this.currentPage++;

      this.pageSizeChanged.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }


  goToLastPage(): void {

    if (
      this.totalPages > 0 &&
      this.currentPage !== this.totalPages
    ) {

      this.currentPage = this.totalPages;

      this.pageSizeChanged.emit({
        currentPage: this.currentPage,
        pageSize: this.pageSize
      });
    }
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (this.rowData && this.rowData.length > 0) {

      const backendPageSize =
        Number(this.rowData[0].pageSize) || 10;

      const backendPageNo =
        Number(this.rowData[0].pageNo) || 1;

      const backendTotalCount =
        Number(this.rowData[0].totalCount) || 0;

      /*
       * Backend remains source of truth.
       * pageSize is converted to number so it never
       * remains as a string in this component.
       */
      this.pageSize = backendPageSize;

      this.currentPage = backendPageNo;

      this.totalRecords = backendTotalCount;

      this.totalPages =
        backendTotalCount > 0 && backendPageSize > 0
          ? Math.ceil(
              backendTotalCount / backendPageSize
            )
          : 0;

      this.start =
        Number(this.rowData[0].rowNum) || 0;

      this.end =
        Number(
          this.rowData[
            this.rowData.length - 1
          ].rowNum
        ) || 0;

    } else {

      /*
       * Important audit fix:
       * clear previous backend pagination metadata
       * when the new response contains no records.
       */
      this.currentPage = 1;
      this.totalPages = 0;
      this.totalRecords = 0;
      this.start = 0;
      this.end = 0;
    }
  }
}